import { render, staticRenderFns } from "./resetMyPwd.vue?vue&type=template&id=50f5d6ef&scoped=true"
import script from "./resetMyPwd.vue?vue&type=script&lang=js"
export * from "./resetMyPwd.vue?vue&type=script&lang=js"
import style0 from "./resetMyPwd.vue?vue&type=style&index=0&id=50f5d6ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5d6ef",
  null
  
)

export default component.exports